<template>
    <v-container fluid class="py-0">
        <div class="text-center">
            <div class="d-flex justify-center align-center">
                <span class="primary--text text-h4 ma-0">{{
                    $route.query.Categories
                }}</span>
            </div>
        </div>
    </v-container>
</template>

<script>
export default {
    name: 'ShopHeader',
    components: {},
    data() {
        return {
            categoryModal: false,
        }
    },
    props: {
        facets: {
            type: Array,
            default: () => [],
        },
    },
    computed: {},
    methods: {
        productLink() {
            if (!this.$route.query.Categories) {
                return ''
            } else {
                const categorySlug = this.$route.query.Categories.toLowerCase().replace(
                    / /g,
                    '-'
                )
                return `/products/${categorySlug}`
            }
        },
    },
}
</script>

<style></style>
